import { RBAC } from 'onc';

export default {
  namespaced: true,
  state: {
    currentRbac: null,
  },
  mutations: {
    SET_CURRENT_RBAC(state, newValue) {
      state.currentRbac = newValue;
    },
  },
  getters: {
    rbacCan: (state, getters, rootState, rootGetters) => (
      operation,
      params,
    ) => {
      const myRole = rootGetters['auth/myRole'];
      return (
        state.currentRbac.can &&
        myRole &&
        state.currentRbac.canSync(myRole, operation, params)
      );
    },
  },
  actions: {
    perms({ commit }, { roles }) {
      const rbac = Object.create(RBAC).init(roles);
      commit('SET_CURRENT_RBAC', rbac);
    },
  },
};

// ===
// Private helpers
// ===
